import * as Yup from 'yup';

export const projectValidationSchema = Yup.object().shape({
  code: Yup.string()
    .required('กรุณากรอกรหัสโครงการ')
    .min(3, 'รหัสโครงการต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(20, 'รหัสโครงการต้องไม่เกิน 20 ตัวอักษร')
    .matches(/^[a-zA-Z0-9_-]+$/, 'รหัสโครงการต้องเป็นภาษาอังกฤษ ตัวเลข และเครื่องหมาย _ หรือ - เท่านั้น'),

  name: Yup.string()
    .required('กรุณากรอกชื่อโครงการ')
    .min(2, 'ชื่อโครงการต้องมีอย่างน้อย 2 ตัวอักษร')
    .max(100, 'ชื่อโครงการต้องไม่เกิน 100 ตัวอักษร'),

  description: Yup.string()
    .max(500, 'รายละเอียดโครงการต้องไม่เกิน 500 ตัวอักษร'),

  status: Yup.string()
    .required('กรุณาเลือกสถานะโครงการ')
    .oneOf(['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED'], 'กรุณาเลือกสถานะโครงการให้ถูกต้อง'),

  isActive: Yup.boolean()
    .required('กรุณาเลือกสถานะการใช้งาน'),

  startDate: Yup.string()
    .required('กรุณาเลือกวันที่เริ่มโครงการ'),

  endDate: Yup.string()
    .required('กรุณาเลือกวันที่สิ้นสุดโครงการ')
    .test('isAfterStartDate', 'วันที่สิ้นสุดต้องอยู่หลังวันที่เริ่มต้น', function(value) {
      const startDate = this.parent.startDate;
      if (!startDate || !value) return true;
      return new Date(value) >= new Date(startDate);
    }),

  workStartTime: Yup.string()
    .required('กรุณากรอกเวลาเริ่มงาน')
    .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'กรุณากรอกเวลาในรูปแบบ HH:mm'),

  workEndTime: Yup.string()
    .required('กรุณากรอกเวลาเลิกงาน')
    .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'กรุณากรอกเวลาในรูปแบบ HH:mm')
    .test('isAfterStartTime', 'เวลาเลิกงานต้องอยู่หลังเวลาเริ่มงาน', function(value) {
      const startTime = this.parent.workStartTime;
      if (!startTime || !value) return true;
      return value > startTime;
    }),

  maxLateTime: Yup.string()
    .required('กรุณากรอกเวลาสูงสุดที่สามารถเข้างานสาย')
    .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'กรุณากรอกเวลาในรูปแบบ HH:mm'),

  latitude: Yup.string()
    .required('กรุณากรอกพิกัดละติจูด')
    .matches(/^-?\d+(\.\d+)?$/, 'พิกัดละติจูดต้องเป็นตัวเลข'),

  longitude: Yup.string()
    .required('กรุณากรอกพิกัดลองจิจูด')
    .matches(/^-?\d+(\.\d+)?$/, 'พิกัดลองจิจูดต้องเป็นตัวเลข'),

  radius: Yup.string()
    .required('กรุณากรอกรัศมี')
    .matches(/^\d+$/, 'รัศมีต้องเป็นตัวเลข และต้องมีค่าไม่ติดลบ')
    .test('isPositive', 'รัศมีต้องเป็นจำนวนบวก', value => {
      return Number(value) >= 0;
    }),
}); 